import { render, staticRenderFns } from "./TwoFactorAuthentication.vue?vue&type=template&id=ffe1e45c&"
import script from "./TwoFactorAuthentication.vue?vue&type=script&lang=js&"
export * from "./TwoFactorAuthentication.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ffe1e45c')) {
      api.createRecord('ffe1e45c', component.options)
    } else {
      api.reload('ffe1e45c', component.options)
    }
    module.hot.accept("./TwoFactorAuthentication.vue?vue&type=template&id=ffe1e45c&", function () {
      api.rerender('ffe1e45c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/global/management/vistas/components/TwoFactorAuthentication.vue"
export default component.exports